export const ymd = 'YYYY-MM-DD';
export const ymdhms = 'YYYY-MM-DD HH:mm:ss';
export const ymdhm = 'YYYY-MM-DD HH:mm';
export const ymdhmss = 'YYYY-MM-DD HH:mm:ss.SSS';
export const marketCloseDay = 5;
export const marketOpenHour = 9;
export const marketOpenMinute = 30;
export const marketCloseHour = 16;
export const marketCloseMinute = 0;
//# sourceMappingURL=constants.js.map